(function () {
  // -----------------------------
  // 1) Publisher (igual que antes)
  // -----------------------------
  function publishFunnelytics(eventName, eventAttributes) {
    if (!window.Shopify?.analytics?.publish) return;

    Shopify.analytics.publish("customFunnelyticsEvent", {
      eventName: eventName,
      eventAttributes: eventAttributes || {}
    });
  }

  // -----------------------------
  // 2) Helpers
  // -----------------------------
  function cleanText(str) {
    return String(str || "").replace(/\s+/g, " ").trim();
  }

  function getTextFromEl(el) {
    if (!el) return "";
    // En tu theme el texto suele estar directo en el <a> o en <summary>
    return cleanText(el.textContent);
  }

  function safeHref(aEl) {
    if (!aEl) return "";
    const href = aEl.getAttribute("href");
    if (!href) return "";
    // ignoramos anchors vacíos
    if (href === "#") return "";
    return aEl.href || href;
  }

  function isDesktopNav(target) {
    return !!target.closest("full-menu.full-menu, ul.thb-full-menu");
  }

  function isMobileNav(target) {
    return !!target.closest('nav#mobile-menu.mobile-menu-drawer');
  }

  function isMobileFeatured(target) {
    return !!target.closest(".mobile-menu-featured__track, .mobile-menu-featured");
  }

  function isPromoArea(target) {
    // Promos desktop (header-full-menu-promotion, vertical, etc.) y promo mobile (mega-menu-promotion)
    return !!target.closest(".header-full-menu-promotion, .header-full-menu-promotion-vertical, .mega-menu-promotion");
  }

  // -----------------------------
  // 3) Construcción de path - Desktop
  // -----------------------------
  function getDesktopTopLevelTitle(target) {
    const topLi = target.closest("ul.thb-full-menu > li");
    if (!topLi) return "";
    const topA = topLi.querySelector(":scope > a.thb-full-menu--link");
    return cleanText(topA ? topA.textContent : topLi.getAttribute("data-item-title") || "");
  }

  function buildDesktopPath(target, clickedText) {
    const path = [];

    // 1) Top level (siempre que exista)
    const top = getDesktopTopLevelTitle(target);
    if (top) path.push(top);

    // 2) Subniveles: buscamos li con data-item-title en submenus (tu theme los pone en 2do/3er nivel)
    //    Tomamos los ancestors dentro del área de menú
    const menuRoot = target.closest("full-menu.full-menu, ul.thb-full-menu");
    if (menuRoot) {
      const candidateLis = [];
      let node = target;
      while (node && node !== menuRoot) {
        if (node.matches && node.matches('li[data-item-title]')) candidateLis.push(node);
        node = node.parentElement;
      }
      // candidateLis viene de adentro hacia afuera; invertimos para orden natural
      candidateLis.reverse().forEach((li) => {
        const t = cleanText(li.getAttribute("data-item-title"));
        // Evitar duplicar top si coincide
        if (t && (!path.length || path[path.length - 1] !== t)) path.push(t);
      });
    }

    // 3) Click actual (si es un link real o un item final)
    if (clickedText) {
      if (!path.length || path[path.length - 1] !== clickedText) path.push(clickedText);
    }

    return path.filter(Boolean);
  }

  // -----------------------------
  // 4) Construcción de path - Mobile
  // -----------------------------
  function buildMobilePath(target, clickedText) {
    const path = [];

    // En mobile, la jerarquía está en <details class="link-container"> con <summary class="parent-link">
    // Vamos subiendo por details anidados y tomamos el summary de cada uno.
    const detailsChain = [];
    let d = target.closest("details.link-container");
    while (d) {
      detailsChain.push(d);
      // subir al details padre (si está anidado)
      d = d.parentElement ? d.parentElement.closest("details.link-container") : null;
    }
    detailsChain.reverse().forEach((det) => {
      const s = det.querySelector(":scope > summary.parent-link");
      const t = cleanText(s ? s.textContent : "");
      if (t) path.push(t);
    });

    // Click actual
    if (clickedText) {
      // Evitar duplicado típico (summary y el mismo texto)
      if (!path.length || path[path.length - 1] !== clickedText) path.push(clickedText);
    }

    return path.filter(Boolean);
  }

  // -----------------------------
  // 5) Publicador estándar de click
  // -----------------------------
  function fireNavEvent(payload) {
    publishFunnelytics("navigation", {
      link_text: payload.link_text || "unknown",
      link_url: payload.link_url || "",
      nav_path: payload.nav_path || "",
      nav_level: payload.nav_level || 0,
      nav_variant: payload.nav_variant || "unknown", // desktop | mobile
      nav_context: payload.nav_context || "menu",     // menu | promo | featured_product | toggle
      element_type: payload.element_type || "unknown",// a | button | summary
      action: payload.action || "click",              // click | expand | collapse
      pagePath: window.location.pathname
    });
  }

  // -----------------------------
  // 6) Listener global (captura)
  // -----------------------------
  document.addEventListener(
    "click",
    function (e) {
      const target = e.target;

      // --- Caso A: Toggle 4to nivel desktop (botón)
      const toggle4 = target.closest("button.submenu-toggle-4");
      if (toggle4) {
        const li = toggle4.closest("li.menu-item-has-children-4");
        const labelA = li ? li.querySelector(":scope .menu-item-row-4 > a.thb-full-menu--link") : null;
        const clickedText = getTextFromEl(labelA) || "submenu-level-4";

        const top = getDesktopTopLevelTitle(toggle4);
        const pathArr = buildDesktopPath(toggle4, clickedText);

        // acción (expand/collapse) según aria-expanded
        const expanded = toggle4.getAttribute("aria-expanded") === "true";
        fireNavEvent({
          link_text: clickedText,
          link_url: labelA ? safeHref(labelA) : "",
          nav_path: pathArr.join(" > "),
          nav_level: pathArr.length,
          nav_variant: "desktop",
          nav_context: "toggle",
          element_type: "button",
          action: expanded ? "collapse" : "expand"
        });
        return;
      }

      // --- Caso B: Mobile expand (summary) -> NO tiene href pero es importante trackearlo
      const mobileSummary = target.closest("nav#mobile-menu.mobile-menu-drawer summary.parent-link");
      if (mobileSummary) {
        const clickedText = getTextFromEl(mobileSummary);
        const pathArr = buildMobilePath(mobileSummary, clickedText);

        // <summary> abre/cierra <details>; el estado real se refleja en el details open (después del click),
        // pero aquí lo marcamos como "expand" (suficiente para analítica).
        fireNavEvent({
          link_text: clickedText || "menu-expand",
          link_url: "",
          nav_path: pathArr.join(" > "),
          nav_level: pathArr.length,
          nav_variant: "mobile",
          nav_context: "toggle",
          element_type: "summary",
          action: "expand"
        });
        return;
      }

      // --- Caso C: Click en anchors (desktop o mobile)
      const a = target.closest("a");
      if (!a) return;

      const href = safeHref(a);
      // Si no tiene href usable, no hacemos nada (puedes cambiar esto si tu theme usa href="#" para abrir cosas)
      if (!href) return;

      const desktop = isDesktopNav(a);
      const mobile = isMobileNav(a);
      if (!desktop && !mobile) return; // sólo trackeamos navegación del header

      const clickedText = getTextFromEl(a);
      const navVariant = desktop ? "desktop" : "mobile";

      // Contextos especiales
      let navContext = "menu";
      if (isMobileFeatured(a)) navContext = "featured_product";
      else if (isPromoArea(a)) navContext = "promo";

      const pathArr = desktop
        ? buildDesktopPath(a, clickedText)
        : buildMobilePath(a, clickedText);

      fireNavEvent({
        link_text: clickedText || "unknown",
        link_url: href,
        nav_path: pathArr.join(" > "),
        nav_level: pathArr.length,
        nav_variant: navVariant,
        nav_context: navContext,
        element_type: "a",
        action: "click"
      });
    },
    true
  );
})();
